import { useEffect, useRef, useState } from "react";
import { LOADING_OVERLAY_DELAY_MS, LOADING_OVERLAY_MIN_VISIBLE_MS } from "@constants/index";

export default function useDelayedLoadingOverlay(isPending) {
  const [showOverlay, setShowOverlay] = useState(false);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);
  const visibleSinceRef = useRef(0);
  const isOverlayVisibleRef = useRef(false);

  useEffect(() => {
    if (isPending) {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }

      if (!isOverlayVisibleRef.current) {
        showTimerRef.current = setTimeout(() => {
          visibleSinceRef.current = Date.now();
          isOverlayVisibleRef.current = true;
          setShowOverlay(true);
        }, LOADING_OVERLAY_DELAY_MS);
      }
    } else {
      if (showTimerRef.current) {
        clearTimeout(showTimerRef.current);
      }

      if (isOverlayVisibleRef.current) {
        const elapsedVisible = Date.now() - visibleSinceRef.current;
        const remainingVisibleTime = Math.max(0, LOADING_OVERLAY_MIN_VISIBLE_MS - elapsedVisible);

        hideTimerRef.current = setTimeout(() => {
          isOverlayVisibleRef.current = false;
          setShowOverlay(false);
        }, remainingVisibleTime);
      }
    }

    return () => {
      if (showTimerRef.current) {
        clearTimeout(showTimerRef.current);
      }
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }
    };
  }, [isPending]);

  return showOverlay;
}
